<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1"><a href="#/5chap1#chap1">Preface</a></p>
<p class="toc1"><a href="#/6page13#chap2">Sparring with Hemingway</a></p>
<p class="toc1"><a href="#/7chap3#chap3">White, Black, and Other Hopes</a></p>
<p class="toc1"><a href="#/8chap4#chap4">The Great Benny Leonard</a></p>
<p class="toc1"><a href="#/9chap5#chap5">Stillman’s Gym</a></p>
<p class="toc1"><a href="#/10chap6#chap6">Hollywood Hokum</a></p>
<p class="toc1"><a href="#/11chap7#chap7">The Heavyweight Championship</a></p>
<p class="toc1"><a href="#/12chap8#chap8">Where Have You Gone, Holly Mims?</a></p>
<p class="toc1"><a href="#/13chap9#chap9">No Room for the Groom</a></p>
<p class="toc1"><a href="#/14chap10#chap10">Marciano and England’s Cockell</a></p>
<p class="toc1"><a href="#/15chap11#chap11">A Champion Proves His Greatness</a></p>
<p class="toc1"><a href="#/16chap12#chap12">The Comeback: Sugar Ray Robinson</a></p>
<p class="toc1"><a href="#/17chap13#chap13">Boxing’s Dirty Business Must Be Cleaned Up Now</a></p>
<p class="toc1"><a href="#/18chap14#chap14">The Death of Boxing?</a></p>
<p class="toc1"><a href="#/19chap15#chap15">The Chinese Boxes of Muhammad Ali</a></p>
<p class="toc1"><a href="#/20chap16#chap16">In Defense of Boxing</a></p>
<p class="toc1"><a href="#/21chap17#chap17">Journey to Zaire</a></p>
<p class="toc1"><a href="#/22chap18#chap18">Leonard-Duran</a></p>
<p class="toc1"><a href="#/23chap19#chap19">Ali-Holmes</a></p>
<p class="toc1"><a href="#/24chap20#chap20">The Welterweights: Sugar Ray and “Hitman” Hearns Walk with Legends</a></p>
<p class="toc1"><a href="#/25chap21#chap21">The Gerry Cooney Story</a></p>
<p class="toc1"><a href="#/26chap22#chap22">The Eight-Minute War: Hagler-Hearns</a></p>
<p class="toc1"><a href="#/27chap23#chap23">Sugar’s Sweet, Marvin’s Sour</a></p>
<p class="toc1"><a href="#/28chap24#chap24">Historic Night in the Ring: Holmes-Spinks</a></p>
<p class="toc1"><a href="#/29chap25#chap25">They Fall Harder When They’re Old: Tyson-Holmes</a></p>
<p class="toc1"><a href="#/30chap26#chap26">Spinks’s Magic Act Is Not Enough</a></p>
<p class="toc1"><a href="#/31chap27#chap27">The Second Coming of George Foreman</a></p>
<p class="toc1"><a href="#/32chap28#chap28">Foreman-Holyfield: The Bigger They Are, the Harder They Don’t Fall</a></p>
<p class="toc1"><a href="#/33chap29#chap29">Tyson vs. Tyson</a></p>
<p class="toc1"><a href="#/34chap30#chap30">The Mystery of the Heavyweight Mystique</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/35chap31#chap31">Epilogue</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/36chap32#chap32">Acknowledgments</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/37chap33#chap33">Index</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/38biography#biography">A Biography of Budd Schulberg</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3-TOC.vue?9a901488